import { CurrentUserActionType } from '../actions/currentUser';
import createReducer from '../utils/createReducer';

const INITIAL_STATE = {};

const reducers = {
  [CurrentUserActionType.CLEAR_CURRENT_USER]: () => ({ ...INITIAL_STATE }),

  [CurrentUserActionType.SET_CURRENT_USER]: (state, { currentUser }) => ({
    groups: currentUser.groups,
    id: currentUser.id,
    name: currentUser.name,
  }),
};

const currentUserReducer = createReducer(reducers, INITIAL_STATE);

export default currentUserReducer;
